import axios from 'axios'

const api = axios.create({
  baseURL: 'https://estoquecasadasbaterias.danyllo106.com'
})

export default api;